<template>
  <section class="_ptm _pbm">
    <v-data-table
      :headers="visibleHeaders"
      :items="items"
      :pagination.sync="pagination"
      hide-actions
      class="v-table-wrapper"
      :class="{'-clickable': computedClickable }"
      :search="search"
    >
      <template #items="{ item, index, selected, expanded }" >
        <slot
          name="items"
          :item="item"
          :index="index"
          :selected="selected"
          :expanded="expanded"
          :visibleHeaders="visibleHeaders"
          :getCellValue="getCellValue"
        >
          <router-link
            tabindex="0"
            v-if="clickable && toRoute"
            :to="toRoute(item)"
            tag="tr"
            class="routed-row">
            <template v-for="(header, j) in visibleHeaders">
              <name-id-concat
                tabindex="0"
                v-if="header.truncate"
                :maxChars="header.maxChars"
                :key="j"
                :value="getCellValue(item, header)"
                tag="td"
              />
              <td
                v-else
                tabindex="0"
                :key="j"
                @click="$emit('cellClicked', item)"
              >
                <template v-if="header.route">
                  <router-link
                    tabindex="0"
                    :to="toRoute(item)"
                  >
                    View Details
                  </router-link>
                </template>
                <template v-else>{{getCellValue(item, header)}}</template>
              </td>
            </template>
          </router-link>
          <tr tabindex="0" v-else>
            <template v-for="(header, j) in visibleHeaders">
              <name-id-concat
                tabindex="0"
                v-if="header.truncate"
                :maxChars="header.maxChars"
                :key="j"
                :value="getCellValue(item, header)" tag="td"
              />
              <template v-else >
                <td
                  tabindex="0"
                  v-if="header.route"
                  :key="j"
                >
                  <router-link
                    tabindex="0"
                    :to="toRoute(item)"
                  >
                    View Details
                  </router-link>
                </td>
                <td
                  v-else
                  tabindex="0"
                  @click="$emit('cellClicked', item)"
                  :key="j"
                >
                  {{getCellValue(item, header)}}
                </td>
              </template>
            </template>
          </tr>
        </slot>
      </template>
    </v-data-table>
    <div class="text-xs-center pt-2" v-if="pages > 1">
      <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
    </div>
  </section>
</template>

<script>
  import { isFunction } from '@/utils'
  import NameIdConcat from '@atoms/ConcatAndEllipseValues.vue'

  export default {
    components: {
      NameIdConcat
    },
    props: {
      headers: Array,
      items: Array,
      search: String,
      clickable: Boolean,
      rowsPerPage: {
        type: Number,
        default: 10
      },
      routedData: {
        type: Boolean,
        default: false
      },
      pathKey: {
        type: String
      },
      toRoute: {
        type: Function,
        default: () => {}
      }
    },
    data() {
      return {
        pagination: {
          page: 1,
          rowsPerPage: 10,
          totalItems: 0
        }
      }
    },
    watch: {
      items: function(val) {
        this.$set(this.pagination, 'totalItems', val.length)
      }
    },
    computed: {
      computedClickable() {
        return this.clickable || (this.$listeners && this.$listeners.cellClicked)
      },
      tableActionContent() {
        return (
          !!this.$slots['tableActions'] || !!this.$scopedSlots['tableActions']
        )
      },
      visibleHeaders() {
        let initialHeaders = this.headers.filter(
          h => (h.visible === undefined || h.visible) && !h.alwaysVisible
        )
        let alwaysVisibleHeaders = this.headers.filter(h => h.alwaysVisible)
        return [...initialHeaders, ...alwaysVisibleHeaders]
      },
      pages() {
        if (
          this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) {
          return 0
        }

        return Math.ceil(
          this.pagination.totalItems / this.pagination.rowsPerPage
        )
      }
    },
    created() {
      if (this.items) {
        this.$set(this.pagination, 'totalItems', this.items.length)
      }
      this.$set(this.pagination, 'rowsPerPage', this.rowsPerPage)
    },
    methods: {
      getCellValue(item, header) {
        if (isFunction(header.value)) return header.value(item)
        else return item[header.value]
      }
    }
  }
</script>
